"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconTextUnderline = Experimental__IconTextUnderline;
exports.IconTextUnderline = IconTextUnderline;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconTextUnderline/index.tsx)
 */
function IconTextUnderline(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M13 15H3v-1.5h10V15Zm-5.038-3.06c-.8 0-1.495-.155-2.085-.465-.58-.31-1.035-.775-1.365-1.395-.32-.62-.48-1.375-.48-2.265V1.05h1.5v6.705c0 .94.215 1.65.645 2.13.43.48 1.025.72 1.785.72s1.355-.24 1.785-.72c.44-.48.66-1.19.66-2.13V1.05h1.485v6.765c0 .89-.16 1.645-.48 2.265a3.175 3.175 0 0 1-1.365 1.395c-.59.31-1.285.465-2.085.465Z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M18 21H6v-2h12v2Zm-5.979-4.994c-1.068 0-1.992-.192-2.772-.576a4.278 4.278 0 0 1-1.8-1.746c-.42-.768-.63-1.71-.63-2.826V2.92h1.998v7.866c0 1.14.282 2.004.846 2.592.576.588 1.362.882 2.358.882 1.02 0 1.812-.294 2.376-.882.576-.588.864-1.452.864-2.592V2.92h1.998v7.938c0 1.116-.216 2.058-.648 2.826a4.125 4.125 0 0 1-1.818 1.746c-.78.384-1.704.576-2.772.576Z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconTextUnderline is deprecated and will be archived soon. Use IconTextUnderline instead.
 */
function Experimental__IconTextUnderline(props) {
  return /*#__PURE__*/_react["default"].createElement(IconTextUnderline, props);
}